import { Input } from '@betterment/samba-react';

interface SearchInputProps {
  handleFocus: () => void;
  search: string;
  setSearch: (val: string) => void;
  isAdmin: boolean;
  placeholder?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  handleFocus,
  setSearch,
  search,
  isAdmin,
  placeholder = `Search by name or email to view a client’s household`,
}) => {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return (
    <Input
      type="text"
      placeholder={placeholder}
      onFocus={handleFocus}
      onChange={handleSearch}
      value={search}
      leadingIcon="Search"
      data-testid="searchBar"
      css={{ maxWidth: isAdmin ? '520px' : undefined, '& input': { textOverflow: 'ellipsis', overflow: 'hidden' } }}
    />
  );
};
